<template>
<div id="main">
    <div class="card">
      <div class="justify-content-center d-flex title-card-sales">
        <div>
             <i class="fas fa-hard-hat"></i>
        </div>
        <div>
            {{dataTemplateAPR.codigoAtividade}}
        </div>
      </div>
      <div>
        <div class="employee-value">
          <div class="employee-expenses">
            <div class="employee-title-verde">Informações APR</div>
          </div>

          <div class="employee-expenses">
            <div class="employee-title">Status </div>
            <div class="status" :style="{'background-color': dataTemplateAPR.colorStatus, 'color': dataTemplateAPR.colorFonte}">{{dataTemplateAPR.statusDescricao}}</div>
          </div>

          <div class="employee-expenses">
            <div class="employee-title">Revisão</div>
              <div class="result-title">{{dataTemplateAPR.revisao}}</div>
          </div>
          <div class="employee-expenses">
            <div class="employee-title">Data de Criação</div>
              <div class="result-title">{{dataTemplateAPR.dataCriacao}}</div>
          </div>

          <div class="linha"></div>

          <div class="employee-expenses">
            <div class="employee-title">Atividade</div>
             <div class="result-title">{{dataTemplateAPR.atividade}}</div>
          </div>

          <div class="employee-expenses">
            <div class="employee-title">Descrição</div>
            <div class="result-title">{{dataTemplateAPR.descricao}}</div>
          </div>

          <div style="width: 100%;">
            <label class="labelsearch">Elaborador</label>
            <b-input v-model="dataTemplateAPR.elaborador"  placeholder="Insira o nome do elaborador da APR" />
          </div>
          <div style="width: 100%;">
            <label class="labelsearch">Aprovador</label>
            <b-input v-model="dataTemplateAPR.aprovador"  placeholder="Insira o nome do aprovador da APR" />
          </div>
          <div style="width: 100%;">
            <label class="labelsearch">Observação</label>
            <b-form-textarea v-model="dataTemplateAPR.observacao" rows="3" placeholder="Observação do template (enviada ao app mobile)" />
          </div>

          <div style="display: flex; width: 100%;"  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.APR_SEARCH_CONTROLLER_APPROVAL)">
            <button class="button-save" @click="DefinirResponsaveis">Definir Elaborador/Aprovador</button>
          </div>

          <div class="buton" v-if="(hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.APR_SEARCH_CONTROLLER_APPROVAL) && dataTemplateAPR.status === 0 || (dataTemplateAPR.status === 3 && dataTemplateAPR.revisao === 1))">

            <div style="display: flex; gap: 8px; width: 100%;">
              <div class="criar">
                <button class="button-save" @click="UpdateTemplate('aprovar')">APROVAR</button>
              </div>
              <div class="criar">
                <button class="button-cancel" @click="UpdateTemplate('reprovar')">REPROVAR</button>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
</div>
</template>

<script>
import PanelByApr from './PanelByApr'
export default PanelByApr
</script>

<style scoped>
#main{
    height: 100%;
}
.status{
  font-size: 12px;
  margin-top: 10px;
  width: 60%;
  padding: 5px;
  display: flex;
  justify-content: center;
  font-weight: bold;
  border-radius: 16px;
}
.label-search{
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 10px;
  font-weight: bold;
}
.title-card-sales {
  font-size: 14px;
  background: #008144;
  padding: 10px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  column-gap: 0.5rem;
}
.result-title{
  font-weight: bold;
  color: #707070;
  font-size: 14px;
}
.sales-value {
  font-size: 12px;
  color: #008144;
  font-weight: bold;
}
.employee-value {
  width: 100%;
  display: flex;
  padding: 1rem;
  font-size: 14px;
  background-color: white;
  flex-direction: column;
  font-family: 'Segoe UI';
  gap:1rem;
  border-radius: 0px 0px 8px 8px;
}

.employee-expenses{
  display: flex;
  flex-direction: column;
}

.employee-title-verde{
  color: #008144;
  font-weight: bold;
}
.linha{
  margin-top: 1rem;
    border-top: 1px solid #c7c7c7;
}
.card{
    margin-bottom: 1rem;
    border-radius: 8px 8px 0px 0px;
}
 .button-cancel{
   background-color: #C12D2D;
   color: white;
 }
 .button-save{
  background-color: #008148;
  color: white;
 }

.button-cancel,
.button-save{
  margin-top: 10;
  font: normal normal 600 13px/21px Segoe UI;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 100%;
  height: 40px;
}
.criar{
  width: 60%;
}
.buton{
  width: 100%;
  display: flex;
  justify-content:  center;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
  gap: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/PanelByApr/PanelByApr.vue